import { render, staticRenderFns } from "./certificationApplication.vue?vue&type=template&id=2bc48d8b&scoped=true&"
import script from "./certificationApplication.vue?vue&type=script&lang=js&"
export * from "./certificationApplication.vue?vue&type=script&lang=js&"
import style0 from "./certificationApplication.vue?vue&type=style&index=0&id=2bc48d8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc48d8b",
  null
  
)

export default component.exports